<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <div class="toggle">
            <input
              v-model="$vuetify.theme.dark"
              @change="onChangeTheme"
              class="toggle-input"
              type="checkbox"
            />
            <div class="toggle-bg"></div>
            <div class="toggle-switch">
              <div class="toggle-switch-figure"></div>
              <div class="toggle-switch-figureAlt"></div>
            </div>
          </div>
        </v-list-item>
        <!-- <v-list-item class="text-center" v-if="isAuth && !isGuide">
          <v-switch
            v-model="swithOnline"
            flat
            color="success"
            hide-details
            :label="'Blueberry Dialer'"
          />
        </v-list-item> -->
        <!-- <v-list-item class="text-center" v-if="isAuth && !isGuide">
          <v-switch
            v-model="swithInboundOnline"
            flat
            color="success"
            hide-details
            :label="'3rd Party Call'"
          />
        </v-list-item> -->
        <v-list-item class="mt-3" v-if="isAuth">
          <VoiceMails />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id == 2">
          <ResponseVoiceMailsForm />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth">
          <TextMessage />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 2">
          <TextMessagesDialog v-if="isAuth" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 2">
          <EmailMessagesDialog v-if="isAuth" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 1">
          <!-- Create agent -->
          <NewAgentForm :role_id="2" v-if="isAuth && user.role_id === 1" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 1">
          <!-- Create agent -->
          <PhonesForm :role_id="2" v-if="isAuth && user.role_id === 1" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 1">
          <!-- Create guide -->
          <NewAgentForm :role_id="3" v-if="isAuth && user.role_id === 1" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 1">
          <UpdateAgentForm v-if="isAuth && user.role_id === 1" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth">
          <NewPasswordForm v-if="isAuth" :user_id="user.id" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 2">
          <AgentPhoneForm v-if="isAuth" :user_id="user.id" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth && user.role_id === 1">
          <SettingsForm v-if="isAuth" />
        </v-list-item>
        <v-list-item class="mt-3" v-if="isAuth">
          <v-btn block @click="signOutHandler">Logout</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NewAgentForm from "@/components/forms/NewAgentForm";
import NewPasswordForm from "@/components/forms/NewPasswordForm";
import UpdateAgentForm from "@/components/forms/UpdateAgentForm";
import SettingsForm from "@/components/forms/SettingsForm";
import PhonesForm from "@/components/forms/PhonesForm";
import AgentPhoneForm from "@/components/forms/AgentPhoneForm";
import VoiceMails from "@/components/forms/VoiceMails";
import TextMessage from "@/components/forms/TextMessage";
import ResponseVoiceMailsForm from "@/components/forms/ResponseVoiceMailsForm";
import TextMessagesDialog from "@/components/dialogs/TextMessagesDialog";
import EmailMessagesDialog from "@/components/dialogs/EmailMessagesDialog";

export default {
  name: "Settings",
  data() {
    return {
      online: false,
      inboundOnline: false,
    };
  },
  components: {
    AgentPhoneForm,
    NewAgentForm,
    NewPasswordForm,
    UpdateAgentForm,
    SettingsForm,
    PhonesForm,
    VoiceMails,
    TextMessage,
    ResponseVoiceMailsForm,
    TextMessagesDialog,
    EmailMessagesDialog,
  },
  methods: {
    ...mapActions({
      signOut: "auth/signOut",
      setOnline: "twilio/setOnline",
      setOffline: "twilio/setOffline",
    }),

    handleStatus(user_id, field, status) {
      this.$axios
        .post("/user/change-status", {
          user_id: user_id,
          field: field,
          status: status,
        })
        .catch((err) => {
          console.log(err);
        });
    },

    signOutHandler() {
      localStorage.removeItem("leadFilters");
      localStorage.removeItem("followUpFilters");
      this.handleStatus(this.user.id, "online", 0);
      this.handleStatus(this.user.id, "in_call", 0);
      this.online = false;
      this.signOut();
      this.$router.replace({
        name: "SignIn",
      });
    },

    signIn() {
      this.$router.replace({
        name: "SignIn",
      });
    },

    onChangeTheme() {
      localStorage.setItem("blueberry_dark-theme", this.$vuetify.theme.dark);
    },

    changeStatus(e) {
      this.$axios
        .put("/user/active", {
          active: e,
          user_id: this.user.id,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((e) => {
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      isAuth: "auth/isAuth",
      user: "auth/user",
      isGuide: "auth/isGuide",
    }),
    swithOnline: {
      get: function () {
        return this.online;
      },
      set: function () {
        if (this.online) {
          this.$socket.emit("agent-online", {
            user_id: this.user.id,
            online: 0,
          });
          this.setOffline();
        } else {
          this.$socket.emit("agent-online", {
            user_id: this.user.id,
            online: 1,
          });
          this.setOnline(this.user.id);
        }

        this.online = !this.online;
      },
    },
  },
};
</script>

<style lang="scss">
// Mixins
@mixin crater($top, $left, $size) {
  content: "";
  position: absolute;
  top: $top;
  left: $left;
  width: $size;
  height: $size;
  background-color: #efeeda;
  border-radius: 100%;
  border: 4px solid #dee1c5;
}

@mixin cloudBubble($top, $right, $width, $height, $deg) {
  content: "";
  display: block;
  position: relative;
  top: $top;
  right: $right;
  width: $width;
  height: $height;
  border: 8px solid #d4d4d2;
  border-radius: 100%;
  border-right-color: transparent;
  border-bottom-color: transparent;
  transform: rotateZ($deg);
  background-color: #fff;
}

// Day State
.toggle {
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 90px;
  margin: 10px auto;
  padding: 4px;
  border-radius: 40px;
}

.toggle:before,
.toggle:after {
  content: "";
  display: table;
}

.toggle:after {
  clear: both;
}

.toggle-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #c0e6f6;
  border-radius: 40px;
  border: 4px solid #81c0d5;
  transition: all 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.toggle-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid red;
  border-radius: 40px;
  z-index: 2;
  opacity: 0;
}

.toggle-switch {
  position: relative;
  width: 30px;
  height: 30px;
  margin-left: 50px;
  background-color: #f5eb42;
  border: 4px solid #e4c74d;
  border-radius: 50%;
  transition: all 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.toggle-switch-figure {
  position: absolute;
  bottom: -14px;
  left: -50px;
  display: block;
  width: 80px;
  height: 30px;
  border: 8px solid #d4d4d2;
  border-radius: 20px;
  background-color: #fff;
  transform: scale(0.4);
  transition: all 0.12s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:after {
    @include cloudBubble(-65px, -42px, 15px, 15px, 70deg);
  }
  &:before {
    @include cloudBubble(-25px, -10px, 30px, 30px, 30deg);
  }
}

.toggle-switch-figureAlt {
  @include crater(5px, 2px, 2px);

  box-shadow: 42px -7px 0 -3px #fcfcfc, 75px -10px 0 -3px #fcfcfc,
    54px 4px 0 -4px #fcfcfc, 83px 7px 0 -2px #fcfcfc, 63px 18px 0 -4px #fcfcfc,
    44px 28px 0 -2px #fcfcfc, 78px 23px 0 -3px #fcfcfc;

  transition: all 0.12s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: scale(0);
}

.toggle-switch-figureAlt:before {
  @include crater(-6px, 18px, 7px);
}

.toggle-switch-figureAlt:after {
  @include crater(19px, 15px, 2px);
}

// Night State
.toggle-input:checked ~ .toggle-switch {
  margin-left: 0;
  border-color: #dee1c5;
  background-color: #fffdf2;
}

.toggle-input:checked ~ .toggle-bg {
  background-color: #484848;
  border-color: #202020;
}

.toggle-input:checked ~ .toggle-switch .toggle-switch-figure {
  margin-left: 40px;
  opacity: 0;
  transform: scale(0.1);
}

.toggle-input:checked ~ .toggle-switch .toggle-switch-figureAlt {
  transform: scale(1);
}
</style>